import { TransformInt } from '../../../shared/decorators/transform-int.decorator';

import { CreateReportTemplateDto } from './create-report-template.dto';

/**
 * Update report template DTO
 */
export class UpdateReportTemplateDto extends CreateReportTemplateDto {
	@TransformInt()
	id!: number;
}
